export default class ConfiguracaoImpressaoModel {
    showSubItens = true;
    gerarPDFHorizontal = true;
    tipoExportacaoXLS = 1;
}
